import React from 'react';
import { makeStyles, TextField, TextFieldProps } from '@material-ui/core';

export const TextFieldBoxed: React.FC<TextFieldProps> = (props) => {
  const styles = useTextFieldStyles();
  return <TextField {...props} variant='outlined' fullWidth className={styles.textField} />;
};

const useTextFieldStyles = makeStyles({
  textField: {
    [`& fieldset`]: {
      borderRadius: 0,
    },
    margin: '24px 0',
  },
});
